import {combineReducers} from 'redux';
import {FETCH_POST, _SUCCESS} from './reducers-const';

function title(state = '', action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data;
    default:
      return state;
  }
}

function date(state = '', action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data;
    default:
      return state;
  }
}

function content(state = '', action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data;
    default:
      return state;
  }
}

function labels(state = [], action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data;
    default:
      return state;
  }
}

function withMedia(state = false, action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data;
    default:
      return state;
  }
}

function basePath(state = '', action) {
  switch (action.type) {
    case `${FETCH_POST}${_SUCCESS}`:
      return action.data.basePath;
    default:
      return state;
  }
}

export type Label = {
  name: string;
  path: string
};

interface FullArticle {
  title: string;
  date: string;
  content: string;
  labels: Label[];
  withMedia: boolean;
  basePath: string;
  id: string;
}

export type Article = Partial<FullArticle>;

export default combineReducers<Article>({
  title,
  date,
  content,
  labels,
  withMedia,
  basePath
});
